<template>
	<div  >
		<!-- <div class="bg-w p-4 mt-3 p-3 flex alcenter">
			<img :src="classInfo.teacher_info.photo_image" alt="" class="photo-50" style="border-radius: 2px;" />
			<div class="flex around" style="flex: 1;">
				<div class="text-center" style="width: 20%;">
					<div>{{$t('appointment.teacher')}}</div>
					<div class="flex mt-2 center">
						<div class="text-underline">{{classInfo.teacher_info.name}}{{classInfo.teacher_info.surname}}</div>
						<img src="../../assets/image/staduents/report-message.png" alt="" class="ml10" />
					</div>
				</div>
				<div class="text-center" style="width: 10%;">
					<div>{{$t('cashDesk.subject')}}</div>
					<div class="mt-2">
						{{'DSE-數學'}}
					</div>
				</div>
				<div class="text-center" style="width: 10%;">
					<div>{{$t('common.reportType')}}</div>
					<div class="mt-2">
						{{$t('common.progressReport')}}
					</div>
				</div>
				<div class="text-center" style="width: 10%;">
					<div>{{$t('studentsCom.classDate')}}</div>
					<div class="mt-2">
						{{'2025-06-13'}}
					</div>
				</div>
				<div class="text-center" style="width: 10%;">
					<div>{{$t('common.remainingClasses')}}</div>
					<div class="mt-2">
						10
					</div>
				</div>
				<div class="text-center" style="width: 10%;">
					<div>{{$t('common.unbookedClassroom')}}</div>
					<div class="mt-2">
						5
					</div>
				</div>
				<div class="">
					<div class="mt-3">
						<img src="../../assets/image/staduents/report-appointment.png" alt="" />
						<img src="../../assets/image/staduents/report-buy.png" alt="" class="ml10" />
					</div>
				</div>
			</div>
		</div> -->
		<div class="bg-w p-3">
			<div class="ftr-1-25 ftw600">
				{{$t('common.progressReport') }}
			</div>
			<div class="mt-3 cl-theme ftw600">
				{{$t('studentsCom.courseContent') }}
			</div>
			<div class="mt-2">
				<span class="ftw600">{{$t('studentsCom.keyCourse')}}:</span>
				{{info.educational_highlights}}
			</div>
			<div class="mt-2">
				<span class="ftw600">{{$t('studentsCom.learningObjectives')}}:</span>
				{{info.learning_objectives}}
			</div>
			<div class="mt-3 cl-theme ftw600">
				{{$t('studentsCom.classroomPerformance') }}
			</div>
			<div class="mt-3">
				<a-table   :columns="columnsClass" rowKey="activity_id"  :pagination="false"
					 :data-source="datasClass" >
					
					
				</a-table>
			</div>
		</div>
		<div class="bg-w p-3 mt-3">
			<div class="cl-theme ftw600">
				{{$t('studentsCom.examPerformance') }}
			</div>
			<div class="mt-3">
				<a-table   :columns="columnsExam" rowKey="activity_id"  :pagination="false"
					 :data-source="datasClass1" >
					
					
				</a-table>
			</div>
		</div>
		<div class="bg-w p-3 mt-3">
			<div class="cl-theme ftw600">
				{{$t('studentsCom.teacherMessage') }}
			</div>
			<div class="flex alcenter space col-md-7 col-sm-7">
				<div>
					<div class="mt-2 cl-black ftw600">
						{{$t('teacherIndex.progressReport9') }}
					</div>
					<div>{{info.short_commentary}}</div>
					<div class="mt-2 cl-black ftw600">
						{{$t('studentsCom.studySuggestions') }}
					</div>
					<div>{{info.learning_advice}}</div>
					<div class="mt-2 cl-black ftw600">
						{{$t('studentsCom.nextPreview') }}
					</div>
					<div>{{info.next_target}}</div>
				</div>
				<div class="border-gray" style="width: 100px;height: 100px;text-align: center;">
					<div class="ftr-3 cl-theme ftw600">
						{{getScore(info.score_overall)}}
					</div>
					<div class="" style="margin-top: -10px;">
						{{$t('studentsCom.overallEvaluation')}}
					</div>
				</div>
			</div>
			
		</div>
		<div class="bg-w p-3 mt-3" >
			<div class="cl-theme ftw600">
				{{$t('studentsCom.supportYou')}} 
			</div>
			<div>
				{{info.support}}
			</div>
			
		</div>
		<div class="mt-3 flex">
			<div class="bg-w p-3" style="height: 200px; width: 60%;">
				<div class="cl-theme ftw600">
					{{$t('studentsCom.warmReminder')}} 
				</div>
				<div>
					{{$t('common.progressReportHint')}}
				</div>
				<div class="flex center mt-3">
					<div class="btn btn-outline-theme" @click="navBack()">
						{{$t('common.back')}}
					</div>
				</div>
			</div>
			<div class="bg-w ml15 br4 p-3" style="max-width: 400px;"
				v-for="(item,index) in courseSaleList">
				<div class="cl-red ftw600">
					{{ $t('userCenter.limitedPromotion') }}
				</div>
				<div class="mt-2 d-flex align-items-center">
					<img :src="item.teacher_photo_image" alt="" class="userCenter-head" />
					<div class=" ml10 ftw600">
						{{item.teacher_name}} {{item.teacher_surname}}
					</div>
				</div>
				<div class="ftw600 mt-1">
					<!-- 正式课 -->
					{{$t('becomeTeacher.formalClass')}}
				</div>
				<div class="flex alcenter">
					<div style="width: 50px;"> {{$t('forClassIndex.class')}}:</div>{{item.course_classify_name}} {{item.course_name}}
				</div>
				<div class="flex alcenter">
					<div style="width: 50px;"> {{$t('appointment.coursePackage')}}:</div>
					{{$t('common.numberClass',{num:item.quantity})}} x
					{{getCurrency()}}{{convertCurrency(item.price/item.quantity)}}(50{{$t('forClassIndex.minute')}})
				</div>
				<div class="flex alcenter">
					<div style="width: 50px;"> {{$t('userCenter.timeLimit')}}:</div>
					{{convertToTimeZone(item.finish_time).formattedTime}}
				</div>
				<div class="d-flex flex-column align-items-center mt-2">
					<button type="button" class="btn btn-theme bg-theme border-theme px-5"
						@click="toCashDesk(item)">{{ $t('userCenter.purchase') }}</button>
					<div class="ft14 cl-red flex alcenter">
						{{ $t('userCenter.remainingTime') }}
						<countdown :targetTime="convertToTimeZone(item.finish_time).formattedTime" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import countdown from '../../components/countdown.vue'
	export default{
		components:{
			countdown
		},
		data() {
			return{
				studentInfo:{},
				info:{},
				columnsClass:[
					{
						title: this.$t('studentsCom.classroomPerformance'),
						dataIndex: 'classperformance',
					},
					{
						title: this.$t('studentsCom.performance'),
						dataIndex: 'performance',
					},
					{
						title: this.$t('studentsCom.rating'),
						dataIndex: 'rating',
					}
				],
				datasClass:[
					{
						classperformance:this.$t('studentsCom.cPerformance1'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('studentsCom.cPerformance2'),
						performance:'基本上都能掌握課堂的知識',
						rating:'B'
					},
					{
						classperformance:this.$t('studentsCom.cPerformance3'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A-'
					},
					{
						classperformance:this.$t('studentsCom.cPerformance4'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('studentsCom.cPerformance5'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					}
				],
				datasClass1:[
					{
						classperformance:this.$t('teacherIndex.progressReport2'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport3'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport4'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport5'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport6'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport7'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					},
					{
						classperformance:this.$t('teacherIndex.progressReport8'),
						performance:'大部份課堂都很留心上堂，可能間中有少少分神',
						rating:'A'
					}
				],
				columnsExam:[
					{
						title: this.$t('studentsCom.testtaking'),
						dataIndex: 'classperformance',
					},
					{
						title: this.$t('studentsCom.performance'),
						dataIndex: 'performance',
					},
					{
						title: this.$t('studentsCom.rating'),
						dataIndex: 'rating',
					}
				],
				courseSaleList:[]
			}
		},
		created() {
			this.studentInfo = JSON.parse(this.$route.query.item)
			this.getDetails()
			console.log("---this.studentInfo",this.studentInfo);
			this.teacherCourseSaleList()
		},
		methods:{
			toCashDesk(item,boo) {
				this.$router.push('/cashDesk?item=' + JSON.stringify(item)+'&teacher_course_sale_id='+item.id)
			},
			teacherCourseSaleList(){
				this.$http.api('user/teacherCourseSaleList', {
					teacher_id:this.studentInfo.teacher_id
				}).then(res=>{
					console.log("res",res.list);
					this.courseSaleList.push(res.list[0]) 
				})
			},
			navBack(){
				this.$router.back()
			},
			getDetails(){
				this.$http.api('user/reportDetailNew',{id:this.studentInfo.id}).then(res=>{
					if(res.info){
						this.info = res.info
						this.datasClass[0].performance = res.info.remark_concentration
						this.datasClass[0].rating = this.getScore(res.info.score_concentration)
						
						this.datasClass[1].performance = res.info.remark_degree_mastery
						this.datasClass[1].rating = this.getScore(res.info.score_degree_mastery)
						
						this.datasClass[2].performance = res.info.remark_degree_participation
						this.datasClass[2].rating = this.getScore(res.info.score_degree_participation)
						
						this.datasClass[3].performance = res.info.remark_range_advancement
						this.datasClass[3].rating = this.getScore(res.info.score_range_advancement)
						
						this.datasClass[4].performance = res.info.remark_assignment
						this.datasClass[4].rating = this.getScore(res.info.score_assignment)
						
						
						this.datasClass1[0].performance = res.info.remark_time_management_planning
						this.datasClass1[0].rating = this.getScore(res.info.score_time_management_planning)
						
						this.datasClass1[1].performance = res.info.remark_savvy
						this.datasClass1[1].rating = this.getScore(res.info.score_savvy)
						
						this.datasClass1[2].performance = res.info.remark_answering_speed
						this.datasClass1[2].rating = this.getScore(res.info.score_answering_speed)
						
						this.datasClass1[3].performance = res.info.remark_accuracy_rating
						this.datasClass1[3].rating = this.getScore(res.info.score_accuracy_rating)
						
						this.datasClass1[4].performance = res.info.remark_strategy
						this.datasClass1[4].rating = this.getScore(res.info.score_strategy)
						
						this.datasClass1[5].performance = res.info.remark_stress_management
						this.datasClass1[5].rating = this.getScore(res.info.score_stress_management)
						
						this.datasClass1[6].performance = res.info.remark_inspection_strategy
						this.datasClass1[6].rating = this.getScore(res.info.score_inspection_strategy)
					}
				})
			},
			getScore(score){
				if(score==''){
					return ' '
				}
				let num = Number(score)
				if(num<=50){
					return 'C-'
				}else if(num>50&&num<=55){
					return 'C'
				}else if(num>55&&num<=60){
					return 'C+'
				}else if(num>60&&num<=65){
					return 'B-'
				}else if(num>65&&num<=70){
					return 'B'
				}else if(num>70&&num<=75){
					return 'B+'
				}else if(num>75&&num<=80){
					return 'A-'
				}else if(num>80&&num<=90){
					return 'A'
				}else if(num>90){
					return 'A+'
				}
			},
		}
	}
</script>

<style>
	.userCenter-head {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
</style>